
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import searchGetActions from '../../sagas/search';
import { getToken } from '../../reducers/auth';
import { getParamsValues, getSearchParams, getSelectedObjectType } from '../../reducers/search';
import { getProjectKatuzeItems } from '../../reducers/project';
import { getIsknDate } from '../../reducers/isknExplorer';
import isknExplorerGetActions from '../../sagas/isknExplorer';

import View from './IsknObjectExplorer.view';

const IsknObjectExplorer = () => {

    const dispatch = useDispatch();
    const searchActions = searchGetActions(dispatch);
    const isknExplorerActions = isknExplorerGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const selectedObjectType = useSelector(state => getSelectedObjectType(state.search));
    const paramsValues = useSelector(state => getParamsValues(state.search));
    const searchParams = useSelector(state => getSearchParams(state.search, selectedObjectType));
    const isknDate = useSelector(state => getIsknDate(state.isknExplorer));

    React.useEffect(() => {
        if (isknDate) {
            searchActions.getParamsValues(
                token,
                projectKatuzeItems.map(item => item.kod),
                isknDate
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isknDate]);

    const handleChangeIsknDate = (isknDate) => {
        isknExplorerActions.setIsknDate(isknDate);
    }

    const handleChangeSelectedObjectType = (objectType) => {
        searchActions.selectObjectType(objectType);
    }

    const handleSearchClick = async () => {
        searchActions.searchObject(
            token,
            selectedObjectType,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            searchParams
        );
    }

    return (
        <View
            isknDate={isknDate}
            selectedObjectType={selectedObjectType}
            searchParamsValues={paramsValues}
            onChangeIsknDate={handleChangeIsknDate}
            onChangeSelectedObjectType={handleChangeSelectedObjectType}
            onSearchClick={handleSearchClick}
        />
    );
}

export default IsknObjectExplorer;
